import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-delivery-table.scss'

export default register(`section-delivery-table`, {
    onLoad() {

    },
    onUnload() {

    },
})